import { render, staticRenderFns } from "./PayPanel_Culinarymobile.vue?vue&type=template&id=3a0af2c2&scoped=true&"
import script from "./PayPanel_Culinarymobile.vue?vue&type=script&lang=js&"
export * from "./PayPanel_Culinarymobile.vue?vue&type=script&lang=js&"
import style0 from "./PayPanel_Culinarymobile.vue?vue&type=style&index=0&id=3a0af2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0af2c2",
  null
  
)

export default component.exports